module.exports = __webpack_public_path__ + "static/ads-example-21da0dfa36e71a80085629b3b2aad0bd.jpg";